import { createFileRoute, redirect } from '@tanstack/react-router';
import { agreementSectionPath } from '@/lib/agreement-sections';
import { parseAgreementType, type AgreementTypeSearch } from '@/lib/agreement-type-search';
import { AGREEMENT_TYPE_VALUES, type AgreementType } from '@/features/service-agreements/types';

/**
 * The orders have a page per sales type, in the type's sidebar section; the bare address — old
 * links, the overview's figures, `?type=` deep links — lands on the type's page.
 */
export const Route = createFileRoute('/_app/service-agreement/orders/')({
  staticData: { featureKey: 'service-agreements' },
  validateSearch: (search: Record<string, unknown>): AgreementTypeSearch<AgreementType> =>
    parseAgreementType(search, AGREEMENT_TYPE_VALUES),
  beforeLoad: ({ search }) => {
    throw redirect({ href: agreementSectionPath('orders', search.type), replace: true });
  },
});
